import { DomainSessionId, DomainUserId } from '@hc-frontend/core-types';
import { z } from 'zod';

export const FetchRealPhoneValidationPayloadDTO = z.object({
  phone: z.string(),
  domainUserId: DomainUserId.optional(),
  domainSessionId: DomainSessionId.optional(),
});

// eslint-disable-next-line no-redeclare
export type FetchRealPhoneValidationPayloadDTO = z.infer<
  typeof FetchRealPhoneValidationPayloadDTO
>;

export const FetchRealPhoneValidationResponseDTO = z.object({
  status: z.string(),
  error_text: z.string(),
  phone_type: z.string(),
});

// eslint-disable-next-line no-redeclare
export type FetchRealPhoneValidationResponseDTO = z.infer<
  typeof FetchRealPhoneValidationResponseDTO
>;
